import { ColorCodeContainer, Wrapper, WrapperColumn, WrapperRow } from 'components/auditorium/auditorium.style'
import { AuditoriumRelease } from 'components/auditorium/release'
import { ActionButton } from 'components/button/button.styled'
import ColorCode from 'components/colorCode'
import { LoadingContainer } from 'components/loadingContainer'
import { ModeSelection } from 'components/modeSelection/modeSelection'
import ComplimentaryCheckbox from 'components/seatSelector/components/complimentaryCheckbox'
import { SeatSummary } from 'components/seatSelector/components/seatSummary'
import { SmallTitle, Title } from 'components/seatSelector/seatSelector.style'
import { useSellingTypeForSeats } from 'hooks/admin/useRelease'
import React, { Dispatch, SetStateAction, useState } from 'react'
import { EventDetails } from 'types/Event'

const COLOR_CODES = [
    { color: '#F2DC4E', label: 'Helyileg értékesített helyek' },
    { color: '#F28D2B', label: 'Online értékesített helyek' },
    { color: '#69707A', label: 'Szabad helyek' },
    { color: '#CE0000', label: 'Ön által kiválaszott helyek' },
]

interface Props {
    currentEvent: EventDetails
    selectedSeats: string[]
    changeSelectedSeats: (seats: string[]) => void
    totalPrice: number
    actionLabel: string
    actionHandler: (selectedSeats: string[]) => void
    complimentaryButton?: boolean
    isComplimentary?: boolean
    setIsComplimentary?: Dispatch<SetStateAction<boolean>>
}

export const SeatBasedRelease: React.FC<Props> = ({
    currentEvent,
    selectedSeats,
    changeSelectedSeats,
    totalPrice,
    actionLabel,
    actionHandler,
    complimentaryButton = false,
    isComplimentary,
    setIsComplimentary,
}) => {
    const eventId = currentEvent.event_id
    const { data: sellingTypeMap, isLoading: isLoadingSellingTypeMap, error } = useSellingTypeForSeats(eventId)
    const [auditoriumViewMode, setAuditoriumViewMode] = useState<'floor' | 'gallery'>('floor')

    const galleryExists = !!currentEvent.location.auditorium?.gallery

    // Determine which auditorium data to show
    const isGallery = auditoriumViewMode === 'gallery'
    const auditoriumData = isGallery ? currentEvent.location.auditorium.gallery : currentEvent.location.auditorium

    return (
        <LoadingContainer isLoading={isLoadingSellingTypeMap} error={error}>
            <Title>Válassza ki ülőhelyét!</Title>
            <WrapperRow style={{ justifyContent: 'space-around', gap: '2rem' }}>
                <WrapperColumn>
                    <Wrapper>
                        {galleryExists ? (
                            <ModeSelection
                                options={[
                                    { value: 'floor', label: 'Földszint' },
                                    { value: 'gallery', label: currentEvent.location.auditorium.gallery?.gallery_name || 'Karzat' },
                                ]}
                                selectedValue={auditoriumViewMode}
                                onChange={setAuditoriumViewMode}
                                buttonClassName="my-button"
                                selectedButtonClassName="selected"
                            />
                        ) : null}
                    </Wrapper>

                    {auditoriumData && (
                        <AuditoriumRelease
                            key={galleryExists ? auditoriumViewMode : 'floor'}
                            rows={auditoriumData.rows}
                            columns={auditoriumData.columns}
                            seats={auditoriumData.seats}
                            tickets={currentEvent.tickets || []}
                            onSelectedSeatsChange={changeSelectedSeats}
                            middleColumn={auditoriumData.middle_column}
                            eventId={eventId}
                            isGallery={isGallery}
                            sellingTypeMap={sellingTypeMap}
                            galleryName={isGallery && 'gallery_name' in auditoriumData ? auditoriumData.gallery_name : undefined}
                        />
                    )}
                </WrapperColumn>

                <WrapperColumn>
                    <ColorCodeContainer>
                        {COLOR_CODES.map(({ color, label }) => (
                            <ColorCode key={label} color={color} label={label} />
                        ))}
                    </ColorCodeContainer>

                    {complimentaryButton && <ComplimentaryCheckbox isChecked={isComplimentary} onChange={setIsComplimentary} />}

                    <ActionButton label={actionLabel} style={{ marginTop: '2rem' }} onClick={() => actionHandler(selectedSeats)} />
                </WrapperColumn>
            </WrapperRow>

            {selectedSeats.length > 0 && (
                <>
                    <SmallTitle>Kiválasztott helyek</SmallTitle>
                    <SeatSummary currentEvent={currentEvent} selectedSeats={selectedSeats} totalPrice={totalPrice} />
                </>
            )}
        </LoadingContainer>
    )
}
